module.exports = __webpack_public_path__ + "img/visa.6dc83302.png";